import ReactMarkdown from "react-markdown";
import { Link } from "@radix-ui/themes";
import { rewriteUrl } from "~/utils/rewrite-news-urls";

export const renderMarkdown = (content: string) => {
  return (
    <ReactMarkdown
      components={{
        a: (props) => {
          const href = rewriteUrl(props.href || "");

          return (
            <Link
              href={href}
              target="_blank"
              rel="noopener noreferrer"
              style={{
                color: "var(--demo-primary-color, #4095A8)",
                textDecoration: "underline",
              }}
            >
              {props.children}
            </Link>
          );
        },
        p: ({ children }) => <>{children}</>,
      }}
    >
      {content}
    </ReactMarkdown>
  );
};

// Extract "What's going well" and "What's not" sections from markdown
export const parseInsightSections = (markdownText: string) => {
  const sections = { positive: "", negative: "" };

  // Match "What's going well" with ellipsis or colon - use exec for capturing groups
  const positiveRegex = /what['']s going well[…:.]*\s*([\s\S]*?)(?=what['']s not|$)/gi;
  const positiveMatch = positiveRegex.exec(markdownText);
  if (positiveMatch && positiveMatch[1]) {
    sections.positive = positiveMatch[1].trim();
  }

  // Match "What's not" with ellipsis or colon - use exec for capturing groups
  const negativeRegex = /what['']s not[…:.]*\s*([\s\S]*?)(?=what['']s going well|$)/gi;
  const negativeMatch = negativeRegex.exec(markdownText);
  if (negativeMatch && negativeMatch[1]) {
    sections.negative = negativeMatch[1].trim();
  }

  return sections;
};
